import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import ContactForm from './ContactForm';
import './QuoteModal.css';

const QuoteModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="quote-modal-root" role="presentation">
      <div className="quote-modal-backdrop" onClick={onClose} aria-hidden="true" />
      <div
        className="quote-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-modal-title"
      >
        <button
          type="button"
          className="quote-modal-close"
          onClick={onClose}
          aria-label="Close quote form"
        >
          <FaTimes />
        </button>
        <ContactForm
          className="quote-modal-form"
          titleId="quote-modal-title"
          title="Get Your Free Part Quote"
          subtitle="Fill out the form below and our team will get back to you quickly."
        />
      </div>
    </div>
  );
};

export default QuoteModal;
